import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";

import { setSingleSelectParams } from "@/src/store/filter";

import RadioGroups from "@/src/components/common/radio-group";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const SingleSelectFilter = ({ filter }) => {
  const reduxSingleSelectItems = useSelector((state) => state.filter.singleselectitems);

  const dispatch = useDispatch();

  const selectedSingleFilter = (key, filter) => {
    const filterByKey = reduxSingleSelectItems.find((singleItem) => singleItem.key === key);

    const findFilter = filter?.find((findItem) => findItem?.id === filterByKey?.value?.id);

    return findFilter || filter[0] || {};
  };

  const handleSingleSelect = (filter, key) => {
    if (Object.keys(filter).length !== 0) {
      const filterObject = {
        key,
        value: filter,
      };
      const newCriteriaParams = reduxSingleSelectItems?.filter((item) => item.key !== key);
      newCriteriaParams.push(filterObject);
      dispatch(setSingleSelectParams(newCriteriaParams));
    }
  };
  return (
    <div className={styles.checkBoxWrapper}>
      <RadioGroups
        property={filter}
        onChange={(filter, key) => handleSingleSelect(filter, key)}
        selected={selectedSingleFilter(filter?.key, filter?.config?.values)}
      />
    </div>
  );
};

SingleSelectFilter.propTypes = {
  filter: PropTypes.object,
};

export default SingleSelectFilter;
